import * as React from 'react';

export const View: React.FC<Props> = (props) => {
    return (
    <div className = "view">
        {props.hideTitle !== true &&
            <div className = "display-title view__title">
                <div>{props.title}</div>
                {props.subtitle &&
                <div className = "view__subtitle">
                    {props.subtitle}
                </div>
                }
            </div>
        }

        <div className = {`view__content ${props.className}`} id = {props.id}>
            {props.children}
        </div>
    </div>
    )
}

interface Props {
    children: React.ReactNode;
    className?: string;
    id?: string;
    title?: string;
    subtitle?: string;
    hideTitle?: boolean;
}